import store from '../store'
import { MessageBox } from 'element-ui'
import Vue from 'vue'
const lang = Vue.prototype
export const oneDayLong = 24 * 60 * 60 * 1000
/* eslint-disable */
// 绑在Vue原型上面
export const util = {
  ridUrlParam(url, aParam) {
    aParam.forEach(item => {
      const fromindex = url.indexOf(`${item}=`) //必须加=号，避免参数值中包含item字符串
      if (fromindex !== -1) {
        // 通过url特殊符号，计算出=号后面的的字符数，用于生成replace正则
        const startIndex = url.indexOf('=', fromindex)
        const endIndex = url.indexOf('&', fromindex)
        const hashIndex = url.indexOf('#', fromindex)

        let reg
        if (endIndex !== -1) {
          // 后面还有search参数的情况
          const num = endIndex - startIndex
          reg = new RegExp(`${item}=.{${num}}`)
          url = url.replace(reg, '')
        } else if (hashIndex !== -1) {
          // 有hash参数的情况
          const num = hashIndex - startIndex - 1
          reg = new RegExp(`&?${item}=.{${num}}`)
          url = url.replace(reg, '')
        } else {
          // search参数在最后或只有一个参数的情况
          reg = new RegExp(`&?${item}=.+`)
          url = url.replace(reg, '')
        }
      }
    })
    const noSearchParam = url.indexOf('=')
    if (noSearchParam === -1) {
      url = url.replace(/\?/, '') // 如果已经没有参数，删除？号
    }
    return url
  },
  /**
   *
   * @example parseTime(new Date(), '{h}:{i}')
   * // @returns 21:20
   * @param { Date } time 时间对象
   * @param {*} cFormat 目标格式
   * @returns { string } 目标格式时间
   */
  parseTime(time, cFormat) {
    if (arguments.length === 0) {
      return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
        time = parseInt(time)
      }
      if (typeof time === 'number' && time.toString().length === 10) {
        time = time * 1000
      }
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key]
      // Note: getDay() returns 0 on Sunday
      if (key === 'a') {
        return ['日', '一', '二', '三', '四', '五', '六'][value]
      }
      if (result.length > 0 && value < 10) {
        value = '0' + value
      }
      return value || 0
    })
    return time_str
  },
  /**
   *
   * @param {*} value 输入的值
   * @param {*} type  类型： 1 金额 2 金额 3 数字类型
   * @returns { string } 格式
   */
  // 用户输入格式化
  valueFormat(value, type) {
    if (type === 1) {
      // 金额类型
      return String(value)
        .replace(/[^0-9\.]+/g, '')
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
        .replace(/^(\d+)\.(\d\d).*$/, '$1.$2')
    } else if (type === 2) {
      // 金额类型
      var str = String(value)
        .replace(/[^0-9\.]+/g, '')
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      if (str && str !== '.') {
        return Number(str).toFixed(2)
      } else {
        return ''
      }
    } else if (type === 3) {
      // 数字类型
      return String(value).replace(/\D+/g, '')
    }
  },
  messageBox(message, type, confirmFunc, cancelFunc) {
    MessageBox({
      type,
      title: lang.$t('229'),
      message,
      confirmButtonText: lang.$t('131'),
      showCancelButton: true,
      cancelButtonText: lang.$t('66'),
      closeOnClickModal: false
    })
      .then(() => {
        confirmFunc()
      })
      .catch(err => {
        cancelFunc()
      })
  },
  permissionCheck(key) {
    return store.getters.permissionList.includes(key)
  },
  getLocationQueryParam(key, type = 'hash') {
    let value = ''
    const reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)')

    if (type === 'search') {
      value = window.location.search.replace('&amp;', '&').substring(1).match(reg)
    } else if (type === 'hash') {
      const hash = window.location.hash
      const index = hash.indexOf('?')
      if (index === -1) {
        value = null
      } else {
        value = hash
          .replace('&amp;', '&')
          .substring(index + 1)
          .match(reg)
      }
    }
    return value === null ? null : unescape(value[2])
  },
  /**
   * @param {*} func 执行的函数
   * @param {*} gap  时间
   * @returns { function } 最终执行的函数
   */
  debounce(func, gap = 500) {
    let timer
    return function () {
      timer && clearTimeout(timer)
      timer = setTimeout(() => {
        func.apply(this, arguments)
      }, gap)
    }
  },
  /**
   * @param {*} func 执行的函数
   * @param {*} wait 等待时间
   * @returns { function } 最终执行的函数
   */
  throttle(func, wait) {
    var previous = 0
    return function () {
      let now = Date.now()
      let context = this
      let args = arguments
      if (now - previous > wait) {
        func.apply(context, args)
        previous = now
      }
    }
  },

  // 图片格式是否满足
  isPicture(key) {
    return ['jpg', 'jpeg', 'png'].includes(key)
  },
  fmtDate(fmt, tags = null) {
    const t = tags ? new Date(tags) : new Date()
    const o = {
      'M+': t.getMonth() + 1, // 月份
      'd+': t.getDate(), // 日
      'h+': t.getHours(), // 小时
      'm+': t.getMinutes(), // 分
      's+': t.getSeconds(), // 秒
      'q+': Math.floor((t.getMonth() + 3) / 3), // 季度
      S: t.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (t.getFullYear() + '').substr(4 - RegExp.$1.length))
    for (const k in o)
      if (new RegExp('(' + k + ')').test(fmt))
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    return fmt
  },
  // 获取 相对于今天 的时间戳
  getTime(n = 10) {
    return new Date().getTime() + n * oneDayLong
  },
  arrUnique(arr, name) {
    var hash = {}
    return arr.reduce((item, next) => {
      hash[next[name]] ? '' : (hash[next[name]] = true && item.push(next))
      return item
    }, [])
  }
}

// 获取位置
export const getPosition = () => {
  let position = false
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function (position) {
      var lat = position.coords.latitude
      var lng = position.coords.longitude
      position = {
        lat,
        lng
      }
    })
  }
  return position
}

// 名称取名规则
export const createName = name => {
  // 英文取首字母大写
  // 是否包含英文已外的字符 包含则取后俩位
  const isNotEn = name.replace(' ', '').match(/\W/g)
  if (isNotEn && isNotEn.length) return name.substr(-2, 2)
  // 如果只是英文 则返回如下：
  // 首字母
  const first = name.charAt(0)
  const splitName = name.split(' ')
  // 是否有空格区分 有则取第一组和最后一组的首字母大写
  if (splitName && splitName.length) {
    if (splitName.length > 1) {
      const str = splitName.slice(-1)
      return `${first}${str[0].charAt(0)}`.toUpperCase()
    }
  }
  return first
}

// 判断元素里是否存在子元素
export const isHas = (str, el) => {
  if (!el) return false
  if (!el.children || !el.children.length) return false
  const list = Array.from(el.children)
  const node = list.filter(node => {
    const classes = node.getAttribute('class')
    if (classes && classes.indexOf && classes.indexOf(str) >= 0) return node
  })
  return node && node.length && node[0]
}

// 生成色值数组
export const createColors = num => {
  // 色值位数补全 标准6位 例；#FFFFFF
  const completionColor = str => {
    return str.length < 2 ? `0${str}` : str
  }
  // @param { number } number 生成个数
  const createColor = number => {
    const create = () => {
      return Array.from({ length: 3 }).map(() => Math.floor(Math.random() * 255))
    }
    return (
      '#' +
      create().reduce((acc, cur, index) => {
        const last = index === 1 ? completionColor(acc.toString(16)) : acc
        return last + completionColor(cur.toString(16))
      })
    )
  }
  return Array.from({ length: Number(num) }).map(() => createColor())
}

// 获取头像
export const getAvatar = sex =>
  ({
    0: require('@/assets/img/avatar-default.png'),
    1: require('@/assets/img/avatar-man.png'),
    2: require('@/assets/img/avatar-woman.png')
  }[sex])

/**
 *  点击元素之外执行的函数 常用于点击弹窗之外隐藏弹窗
 *  @param { classes } class 组
 *  @param { callbackFn } 回掉
 * */
export const outClick = (classes, callbackFn) => {
  const fn = ({ path }) => {
    const state = path.some(item => {
      return classes.some(el => {
        return item?.className?.includes(el)
      })
    })
    callbackFn(!state)
  }
  window.addEventListener('click', fn)
  return fn
}
outClick.prototype.remove = function (fn) {
  window.removeEventListener('click', fn)
}

/**
 * @description: 获取地址栏参数
 * @return {*}
 */
export const getLocationQueryParam = (key, type = 'hash') => {
  let value = ''
  const reg = new RegExp(`(^|&)${key}=([^&]*)(&|$)`)
  if (type === 'search') {
    value = window.location.search.replace('&amp;', '&').substring(1).match(reg)
  } else if (type === 'hash') {
    const hash = window.location.hash
    const index = hash.indexOf('?')
    if (index === -1) {
      value = null
    } else {
      value = hash.replace('&amp;', '&').substring(index + 1).match(reg)
    }
  }
  return value === null ? null : unescape(value[2])
}

/**
 * @description: 删除地址栏url参数
 * @return {*}
 */
export const handleDeleteUrlParam = (key) => {
  let location = window.location;
  let href = window.location.href
  if (href.indexOf("?") != -1) {
    href = href.split("?")[0];
  }
  let baseUrl = href + "?";
  let query = location.href.split('?')[1]
  if (query && query.indexOf(key) > -1) {
    let obj = {}
    let arr = query.split("&");
    for (let i = 0; i < arr.length; i++) {
        arr[i] = arr[i].split("=");
        obj[arr[i][0]] = arr[i][1];
    };
    delete obj[key];
    let url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g,"").replace(/\:/g,"=").replace(/\,/g,"&");
    return url
  };
}
